var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVector8(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 14,
    viewBox: "0 0 18 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 1.00672C16.3036 1.45846 15.5324 1.80396 14.7164 2.02993C14.2784 1.56682 13.6962 1.23858 13.0488 1.0896C12.4013 0.940625 11.7196 0.978099 11.0961 1.19696C10.4725 1.41581 9.93705 1.80549 9.56217 2.31329C9.18729 2.82109 8.99105 3.42251 9 4.0362V4.70496C7.72192 4.73544 6.45547 4.47478 5.31346 3.94622C4.17145 3.41765 3.18932 2.63758 2.45455 1.67548C2.45455 1.67548 -0.454545 7.69432 6.09091 10.3694C4.59311 11.3043 2.80884 11.773 1 11.7069C7.54545 15.0507 15.5455 11.7069 15.5455 4.01614C15.5448 3.82986 15.5253 3.64404 15.4873 3.46107C16.2295 2.78796 16.7533 1.93811 17 1.00672Z",
    stroke: "#0129FA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector8);
export default __webpack_public_path__ + "static/media/Vector8.c7bf760d56745753df725fc9e1cec323.svg";
export { ForwardRef as ReactComponent };